import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Buyer } from '../models/buyer.model';
import { ResponseData } from '../models/helpers.model';
import { FilterOptions } from '../models/filter.model';

@Injectable({
  providedIn: 'root',
})
export class BuyerService {
  constructor(private http: HttpClient) {}

  getBuyers(filterOptions: FilterOptions): Observable<ResponseData<Buyer>> {
    return this.http.post<ResponseData<Buyer>>('/buyers/filter', filterOptions);
  }

  getBuyer(id: string): Observable<Buyer> {
    return this.http.get<Buyer>(`/buyers/${id}`);
  }

  updateBuyer(id: string, data: Partial<Buyer>): Observable<string> {
    return this.http.put<string>(`/buyers/${id}`, data, {
      responseType: 'text' as 'json',
    });
  }

  deleteBuyer(id: string): Observable<string> {
    return this.http.delete<string>(`/buyers/${id}`, {
      responseType: 'text' as 'json',
    });
  }

  addBuyer(data: Partial<Buyer>): Observable<Buyer> {
    return this.http.post<Buyer>('/buyers', data);
  }
}
